import React, { useState } from 'react';
import { List, TextField, SearchInput, NumberField, useNotify } from 'react-admin';
import { CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import Datagrid from '../common/Datagrid';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import ResourceLinkField from '../common/fields/ResourceLinkField';
import { ListActions } from '../common/views/List';
import IconButton from '../common/buttons/IconButton';
import { API_URL } from '../../services/settings';

const customerFilters = [
    <SearchInput source="q" alwaysOn />
];

const RefreshBudgetButton = () => {
    const [loading, setLoading] = useState(false);
    const notify = useNotify();

    const handleRefresh = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/budgets/update_current_stats`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.ok) {
                notify('Budgets refreshed successfully', { type: 'success' });
                window.location.reload();
            } else {
                notify('Failed to refresh budgets', { type: 'error' });
            }
        } catch (error) {
            notify('Error: ' + error.message, { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <IconButton
            icon={loading ? <CircularProgress size={20} /> : <RefreshIcon />}
            onClick={handleRefresh}
            disabled={loading}
        >
            Refresh Budgets
        </IconButton>
    );
};

const CustomerListActions = (props) => (
    <ListActions {...props}>
        <RefreshBudgetButton />
    </ListActions>
);

const CustomerList = props => (
    <List filters={customerFilters} actions={<CustomerListActions />} {...props}>
        <Datagrid>
            <ResourceLinkField label="Id" resource="customers" sortBy="id">
                <TextField source="id" />
            </ResourceLinkField>
            <ResourceLinkField label="Name" resource="customers" sortBy="name">
                <TextField source="name" />
            </ResourceLinkField>
            <NumberField source="current_total_timesheet_hours" label="Timesheet (h)" />
            <NumberField source="current_total_budget_hours" label="Budget (h)" />
            <NumberField source="current_budget_utilization_rate" label="Utilization %" options={{ style: 'percent', minimumFractionDigits: 2 }} />
            <RecordSplitButton />
        </Datagrid>
    </List>
);

export default CustomerList;